import React, {PropTypes} from 'react';
import {MainLayout} from 'components/layouts';
import {HighlightBusinessList} from 'components/highlight-businesses';
import {Link} from 'react-router-dom';

class HighlightBusinessesPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <MainLayout>
        <div>
          <h1>Danh sách Banner</h1>
          [ <Link to="/highlight-businesses/add">Tạo mới doanh nghiệp nổi bật</Link>]
          <HighlightBusinessList/>
        </div>
      </MainLayout>
    );
  }
}

export default HighlightBusinessesPage;



// WEBPACK FOOTER //
// ./pages/highlight-businesses/HighlightBusinessesPage.jsx